export namespace AuthActions {
    export class Login {
        static readonly type = '[Auth] Login';
        constructor(public payload: { token: string, location: string }) {}
    }

    export class Logout {
        static readonly type = '[Auth] Logout';
    }
}